import { ApiRoutes } from '@/settings/routes';
import { App_text } from '@/settings/AppText';
import React from 'react';

export default function CoverPage({ title, cover = null, paragraph = null }) {
    return (
        <div className="min-h-[18rem] relative overflow-hidden shadow-md">
            {/* Background Image */}
            <img
                className="absolute top-0 z-0 object-cover transition-transform duration-500 ease-in-out size-full min-h-[18rem] start-0 group-hover:scale-105"
                src={cover ? ApiRoutes.ASSETS_ENDPOINT + cover : '/media/default-cover.webp'}
                alt={title || 'Page cover image for ' + App_text.APP_NAME}
                width={1920}
                height={500}
                loading="eager"
                fetchPriority="high"
                decoding="async"
            />
            {/* Gradient Overlay - from top (lighter) to bottom (darker) */}
            <div className="absolute inset-0 z-[1] bg-gradient-to-b from-neutral-900/40 via-neutral-900/60 to-neutral-900"></div>

            {/* Content */}
            <div className="relative z-10 max-w-8xl w-full mx-auto flex flex-col items-center gap-1 justify-center min-h-[18rem] px-4">
                {title && <h1 className="text-center text-white custom-style-h1">{title}</h1>}
                {paragraph && <p className="text-center text-gray-100 custom-style-h3 cover-page-paragraph">{paragraph}</p>}
            </div>
        </div>
    );
}
